import React, { useState, useEffect } from "react";
import { Form, Input, message, Button, Row, Col } from "antd";
import {
  isRepeatAccount,
  sendVerifyCode1,
  checkAccountByVerifyCode1,
} from "@services/auth";
import { getUserInfoToLocal, getUserInfoToLocalEmailPhone } from "@/utils/auth";
import { isPhoneOrEmail } from "@/utils/utils";
import PubSub from "pubsub-js";
import "./index.less";

//语言切换
import intl from "react-intl-universal";

import en_US from "@/locales/en_US/index.json";
import zh_CN from "@/locales/zh_CN/index.json";

const locales = {
  en_US,
  zh_CN,
};

export default function ErCode(props) {
  const {
    inputDisabled, //true 手机号｜邮箱不可修改
    type, // 0 手机、邮箱  1 手机  2 邮箱
    isCheck, // 是否验重
    countSpecal, // 监听数值变化，更新当前页面
    nextStep,
    isReg, // 是否为注册，注册的话验重为0未注册才可继续
    forms, // form表单数据
    renzheng, // 认证的情况下必传id
    isForget = false,
    isNow = false, // 是否要跟当前登录账号校验
    isValidateNow = false, // 是否要跟当前登录账号校验,一致方可继续
  } = props;

  const [code, setCode] = useState(
    intl.get("Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68"),
  ); // 验证码文本
  let [countDown, setCountDown] = useState(60); // 倒计时60s
  const [interTime, setInterTime] = useState(null); // 定时器
  const [codeFor, setCodeFor] = useState(false); // 验证码是否禁用

  useEffect(() => {
    intl
      .init({
        currentLocale: localStorage.getItem("language_type") || "zh_CN",
        locales,
      })
      .then(() => {});

    setCode(
      intl.get("Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68"),
    ); //验证码文本

    if (interTime) clearInterval(interTime);
    setCodeFor(false);

    // 下一步
    PubSub.subscribe("erCodeState", (name, value) => {
      const data = {
        account: value.phoneEmail,
        type: isPhoneOrEmail(forms.getFieldValue().phoneEmail),
        code: value.verifyCode,
      };

      checkAccountByVerifyCode1(data).then((res) => {
        if (res.code === 0) {
          PubSub.unsubscribe("erCodeState");
          nextStep(true);
        } else {
          message.error(res.message);
          clearInterval(interTime);
          return false;
        }
      });
    });
  }, [countSpecal, forms]);

  // 发送验证码
  const handleSame = () => {
    if (type == 0) {
      if (forms.getFieldValue().phoneEmail === "") {
        message.error(
          intl.get("Please_e6e6be11-f33f-27b0-811d-4e60ad50a14b_Please"),
        );
        return;
      }
      const email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      const phone = /^1[0-9]{10}$/;
      if (
        !email.test(forms.getFieldValue().phoneEmail) &&
        !phone.test(forms.getFieldValue().phoneEmail)
      ) {
        message.error(intl.get("Invalid_38ead3f9-f9ae-2022-bd8a-290a25c02b29"));
        return;
      }
      if (
        isValidateNow &&
        forms.getFieldValue().phoneEmail !==
          getUserInfoToLocalEmailPhone().email &&
        forms.getFieldValue().phoneEmail !==
          getUserInfoToLocalEmailPhone().mobile
      ) {
        message.error(intl.get("3f940488-330b-2ecc-a117-5ab9936825b5"));
        return;
      }
    } else if (type == 1) {
      if (forms.getFieldValue().phoneEmail === "") {
        message.error(
          intl.get(
            "Please_enter_your_mobile_phone_number_3376cb34-d832-2c8a-acba-e67d7ad974b4",
          ),
        );
        return;
      }
      const phone = /^1[0-9]{10}$/;
      if (!phone.test(forms.getFieldValue().phoneEmail)) {
        message.error(
          intl.get("Invalid_phone_number_01fd94c3-e1e8-20da-8054-58d9ba28b44f"),
        );
        return;
      }
    } else if (type == 2) {
      if (forms.getFieldValue().phoneEmail === "") {
        message.error(
          intl.get(
            "Please_enter_your_email_0f9e45da-8952-2cd2-a8b3-4fd330488dcc",
          ),
        );
        return;
      }
      const email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
      if (!email.test(forms.getFieldValue().phoneEmail)) {
        message.error(
          intl.get(
            "Invalid_email_address_2c0b7b0d-7faa-215b-abaf-aded55258b18",
          ),
        );
        return;
      }
    }

    // 判断当前输入账号跟登录账号是否一致
    if (
      isNow &&
      type == 1 &&
      forms.getFieldValue().phoneEmail == getUserInfoToLocalEmailPhone().mobile
    ) {
      message.error(intl.get("67e9321a-773f-26f4-b0f5-1d48ccc0e3c7"));
      return;
    }
    if (
      isNow &&
      type == 2 &&
      forms.getFieldValue().phoneEmail == getUserInfoToLocalEmailPhone().email
    ) {
      message.error(intl.get("8c911b08-f80c-29eb-b681-9adbc7f08cfb"));
      return;
    }

    let typePhone = isPhoneOrEmail(forms.getFieldValue().phoneEmail);

    if (isCheck) {
      let param = {
        account: forms.getFieldValue().phoneEmail,
        userType:
          localStorage.getItem("login-reg-dots-userType") ||
          sessionStorage.getItem("login-reg-dots-userType"),
      };
      if (renzheng) {
        param = {
          account: forms.getFieldValue().phoneEmail,
          id: getUserInfoToLocal().id,
          userType:
            localStorage.getItem("login-reg-dots-userType") ||
            sessionStorage.getItem("login-reg-dots-userType"),
        };
      }
      isRepeatAccount(param).then((res) => {
        if (isReg) {
          if (res.code === 0) {
            sendCode({
              type: typePhone,
              account: forms.getFieldValue().phoneEmail,
            });
          } else {
            message.error(res.message);
            return;
          }
        } else {
          if (res.code === 0) {
            message.error(res.message);
            return;
          } else {
            sendCode({
              type: typePhone,
              account: forms.getFieldValue().phoneEmail,
            });
          }
        }
      });
    } else {
      sendCode({ type: typePhone, account: forms.getFieldValue().phoneEmail });
    }
  };

  // 发送验证码fun
  function sendCode({ type, account }) {
    // 发送验证码
    setCodeFor(true);
    const interVal = setInterval(() => {
      setCountDown(--countDown);
      setCode(
        `${countDown}${intl.get(
          "Resend_in_54e59247-0c76-20d5-8caa-c059d4c3bca1",
        )}`,
      );
      if (countDown <= 0) {
        setCodeFor(false);
        setCountDown(60);
        setCode(
          intl.get(
            "Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68",
          ),
        );
        clearInterval(interVal);
      }
    }, 1000);
    setInterTime(interVal);
    sendVerifyCode1({ type, account }).then((res) => {
      if (res.code !== 0) {
        message.error(res.message);
        setCodeFor(false);
        setCountDown(60);
        setCode(
          intl.get(
            "Get_verification_code_1481e151-e3f9-21c8-bec6-96251ef32e68",
          ),
        );
        clearInterval(interVal);
        return false;
      }
    });
  }

  return (
    <div className="erCode">
      <Form.Item
        label={
          type == 0
            ? intl.get("Account_9c2bb8e4-91fa-2d8d-a5e9-40c10fe68de7")
            : type == 1
              ? intl.get(
                  "Mobile_phone_number_1369de70-73d4-254a-a628-3eaf126e7217",
                )
              : type == 2
                ? intl.get("Email_c1358cc1-828e-291f-a81e-46733c5fe410")
                : ""
        }
        name="phoneEmail"
        rules={[
          {
            required: true,
            message: intl.get(
              "Please_input_c3e58513-2767-2b92-94e8-996b2e50acb5",
            ),
          },
          {
            validator: (rules, value, callback) => {
              if (type == 0) {
                const email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
                const phone = /^1[0-9]{10}$/;
                if (!email.test(value) && !phone.test(value)) {
                  callback(
                    new Error(
                      intl.get("Invalid_38ead3f9-f9ae-2022-bd8a-290a25c02b29"),
                    ),
                  );
                } else {
                  callback();
                }
              } else if (type == 1) {
                const phone = /^1[0-9]{10}$/;
                if (!phone.test(value)) {
                  callback(
                    new Error(
                      intl.get(
                        "Invalid_phone_number_01fd94c3-e1e8-20da-8054-58d9ba28b44f",
                      ),
                    ),
                  );
                } else {
                  callback();
                }
              } else if (type == 2) {
                const email = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
                if (!email.test(value)) {
                  callback(
                    new Error(
                      intl.get(
                        "Invalid_email_address_2c0b7b0d-7faa-215b-abaf-aded55258b18",
                      ),
                    ),
                  );
                } else {
                  callback();
                }
              }
            },
          },
        ]}
      >
        <Input
          disabled={inputDisabled}
          placeholder={intl.get(
            "Please_input_c3e58513-2767-2b92-94e8-996b2e50acb5",
          )}
          size="large"
        />
      </Form.Item>
      <Form.Item
        label={intl.get(
          "Verification_code_87ffdee6-31f4-272f-8285-202789b378d0",
        )}
        rules={[
          {
            required: true,
            message: intl.get(
              "The_verification_code_cannot_be_empty_0e8fc4d3-59b1-2b44-bb33-d70f9de7e5bb",
            ),
          },
        ]}
        name="verifyCode"
      >
        <Row>
          <Col span={10}>
            {/* <Form.Item> */}
            <Input
              size="large"
              placeholder={intl.get(
                "Please_input_c3e58513-2767-2b92-94e8-996b2e50acb5",
              )}
            />
            {/* </Form.Item> */}
          </Col>
          <Col span={14}>
            <Button
              style={{ width: "100%", padding: "6px" }}
              className="btn"
              type="primary"
              size="large"
              disabled={codeFor}
              onClick={handleSame}
            >
              {code}
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </div>
  );
}
